import * as T from './reportFiltersTypes';
import type { ReportFiltersAction } from './reportFiltersActions';

export interface ReportFiltersState {
  /** Preset ('Today' | 'Yesterday' | '7D' | '30D' | 'This Month') or 'custom:YYYY-MM-DD:YYYY-MM-DD'. */
  dateFilter: string;
}

const initialState: ReportFiltersState = {
  dateFilter: 'Today',
};

export default function reportFiltersReducer(
  state = initialState,
  action: ReportFiltersAction
): ReportFiltersState {
  switch (action.type) {
    case T.SET_REPORT_DATE_FILTER:
      return { ...state, dateFilter: action.payload };
    default:
      return state;
  }
}
